import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper'
import Button from 'material-ui/Button'
import Paper from 'material-ui/Paper'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table'
import Select from 'material-ui/Select'
import Radio, { RadioGroup } from 'material-ui/Radio'
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  FormHelperText
} from 'material-ui/Form'
import * as algoliasearch from 'algoliasearch'

let id = 0
function createData(rating, userbase) {
  id += 1
  return { id, rating, userbase }
}

const data = [
  createData(7.0, 3008),
  createData(8.0, 1322),
  createData(8.5, 706),
  createData(9.0, 471),
  createData(9.5, 170),
  createData(10.0, 53)
]

var client = algoliasearch('5B2G72ZK2N', '1aaebeea6fc4b1dd6695ee42d9d823c1')

class Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: 'Average',
      body: 'Slim',
      race: 'White',
      showPopulation: false,
      popCount: 'Loading...',
      popLoaded: false,
      nbHits: ' ~',
      baseball: '',
      basketball: '',
      all_values: ''
    }
  }

  onNext() {
    this.props.changeRoute(
      `/console/search/saved_searches/filter/life_style/results?query=${
        this.state.all_values
      }&saved_search_id=${this.state.search_id}`
    )
  }

  handleChange = value => {
    let name = value
    let all_values = this.state.all_values
    all_values = all_values + ' ' + value
    this.setState(
      {
        [name]: value,
        all_values: all_values
      },
      () => {
        var index = client.initIndex('Candidates')
        let myComponent = this
        // only query string
        index.search(
          {
            query: this.state.all_values
          },
          function searchDone(err, content) {
            if (err) throw err
            console.log(content)
            myComponent.setState({
              nbHits: content.nbHits
            })
          }
        )
      }
    )
  }

  onShowPopulation = () => {}

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search)
    let saved_search_id = urlParams.get('search_id').replace('%20', '')

    this.setState({
      search_id: saved_search_id
    })
  }

  render() {
    const { classes, theme, location } = this.props
    const { showPopulation } = this.state

    return (
      <div className={classes.root}>
        <br />
        <Typography type="body2" color="inherit" className={classes.flex}>
          Lifestyle Filter
        </Typography>
        <br />
        <Typography>Select the lifestyle items to filter with:</Typography>
        <RadioGroup
          aria-label="baseball"
          name="baseball"
          value={this.state.baseball}
          onChange={() => this.handleChange('baseball')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="baseball"
            control={<Radio />}
            label="Attends Baseball"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="collegiate"
          name="collegiate"
          value={this.state.collegiate}
          onChange={() => this.handleChange('collegiate')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="collegiate"
            control={<Radio />}
            label="Attends Collegiate"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="football"
          name="football"
          value={this.state.football}
          onChange={() => this.handleChange('football')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="football"
            control={<Radio />}
            label="Attends Football"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="basketball"
          name="basketball"
          value={this.state.basketball}
          onChange={() => this.handleChange('basketball')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="basketball"
            control={<Radio />}
            label="Basketball"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="bicycle"
          name="bicycle"
          value={this.state.bicycle}
          onChange={() => this.handleChange('bicycle')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="bicycle"
            control={<Radio />}
            label="Bicycle"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="boats"
          name="boats"
          value={this.state.boats}
          onChange={() => this.handleChange('boats')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="boats"
            control={<Radio />}
            label="Boats"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="fishinghunting"
          name="fishinghunting"
          value={this.state.fishinghunting}
          onChange={() => this.handleChange('fishinghunting')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="fishinghunting"
            control={<Radio />}
            label="Fishing/Hunting"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="golf"
          name="golf"
          value={this.state.golf}
          onChange={() => this.handleChange('golf')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="golf"
            control={<Radio />}
            label="Golf"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="guns"
          name="guns"
          value={this.state.guns}
          onChange={() => this.handleChange('guns')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="guns"
            control={<Radio />}
            label="Guns"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="horses"
          name="horses"
          value={this.state.horses}
          onChange={() => this.handleChange('horses')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="horses"
            control={<Radio />}
            label="Horses"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="iceskating"
          name="iceskating"
          value={this.state.iceskating}
          onChange={() => this.handleChange('iceskating')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="iceskating"
            control={<Radio />}
            label="Ice Skating"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="cooks"
          name="cooks"
          value={this.state.cooks}
          onChange={() => this.handleChange('cooks')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="cooks"
            control={<Radio />}
            label="Likes to Cook/Likes Food"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="motorcycle"
          name="motorcycle"
          value={this.state.motorcycle}
          onChange={() => this.handleChange('motorcycle')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="motorcycle"
            control={<Radio />}
            label="Motorcycle"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="musician"
          name="musician"
          value={this.state.musician}
          onChange={() => this.handleChange('musician')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="musician"
            control={<Radio />}
            label="Musician"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="musiclover"
          name="musiclover"
          value={this.state.musiclover}
          onChange={() => this.handleChange('musiclover')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="musiclover"
            control={<Radio />}
            label="Music Lover"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="other"
          name="other"
          value={this.state.other}
          onChange={() => this.handleChange('other')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="other"
            control={<Radio />}
            label="Other"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="pilot"
          name="pilot"
          value={this.state.pilot}
          onChange={() => this.handleChange('pilot')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="pilot"
            control={<Radio />}
            label="Pilot"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="racecars"
          name="racecars"
          value={this.state.racecars}
          onChange={() => this.handleChange('racecars')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="racecars"
            control={<Radio />}
            label="Race Cars"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="runner"
          name="runner"
          value={this.state.runner}
          onChange={() => this.handleChange('runner')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="runner"
            control={<Radio />}
            label="Runner"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="skiing"
          name="skiing"
          value={this.state.skiing}
          onChange={() => this.handleChange('skiing')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="skiing"
            control={<Radio />}
            label="Skiing"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="skydiver"
          name="skydiver"
          value={this.state.skydiver}
          onChange={() => this.handleChange('skydiver')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="skydiver"
            control={<Radio />}
            label="Skydiver"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="snowboarding"
          name="snowboarding"
          value={this.state.snowboarding}
          onChange={() => this.handleChange('snowboarding')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="snowboarding"
            control={<Radio />}
            label="Snowboarding"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="soccer"
          name="soccer"
          value={this.state.soccer}
          onChange={() => this.handleChange('soccer')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="soccer"
            control={<Radio />}
            label="Soccer"
          />
        </RadioGroup>

        <RadioGroup
          aria-label="tennis"
          name="tennis"
          value={this.state.tennis}
          onChange={() => this.handleChange('tennis')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="tennis"
            control={<Radio />}
            label="Tennis"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="travel"
          name="travel"
          value={this.state.travel}
          onChange={() => this.handleChange('travel')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="travel"
            control={<Radio />}
            label="Travel"
          />
        </RadioGroup>
        <RadioGroup
          aria-label="volleyball"
          name="volleyball"
          value={this.state.volleyball}
          onChange={() => this.handleChange('volleyball')}
          className={classes.group}
        >
          <FormControlLabel
            className={classes.radioButton}
            value="volleyball"
            control={<Radio />}
            label="Volleyball"
          />
        </RadioGroup>
        <br />
        <br />
        <Typography type="body2" color="inherit" className={classes.flex}>
          Population Count is {this.state.nbHits}
        </Typography>
        <div className={classes.buttonNext}>
          <Button
            raised
            onClick={() => this.onNext()}
            color="primary"
            align="center"
            className={classes.button}
          >
            Search Candidates
          </Button>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    oarlow: state.oar.low,
    oarhigh: state.oar.high,
    step: state.step.step
  }
}

function matchDispatchToProps(dispatch) {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, matchDispatchToProps)(Start)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/LifeStyleFilters/scenes/Start/index.js